import Header from './Header';
import Sidebar from './Sidebar'
import { useState, useEffect } from 'react';
import { useAppDispatch } from '@/store/store';
import { fetchUserDetails } from '@/store/feature/UserSlice';

interface LayoutProps {
    children: React.ReactNode;
}


const Layout: React.FC<LayoutProps> = ({ children }) => {
    const dispatch = useAppDispatch();
    // const userDetailsLoading = useAppSelector((state) => state.user.userDetailsLoading);

    useEffect(() => {
        dispatch(fetchUserDetails());
        // if (userDetailsLoading === 'idle') {
        // }
    }, [dispatch]);

    const [isCollapsed, setIsCollapsed] = useState(() => {
        if (typeof window !== 'undefined') {
            const saved = localStorage.getItem('sidebarCollapsed');
            return saved === 'true';
        }
        return false;
    });

    const [isMobileOpen, setIsMobileOpen] = useState(false);

    const toggleSidebar = () => {
        setIsCollapsed(prev => {
            const newState = !prev;
            localStorage.setItem('sidebarCollapsed', String(newState));
            return newState;
        });
    };

    const toggleMobileSidebar = () => {
        setIsMobileOpen(prev => !prev);
    };

    return (
        <div className='min-h-screen bg-[#f1f1f1]'>
            <Sidebar
                isCollapsed={isCollapsed}
                toggleSidebar={toggleSidebar}
                isMobileOpen={isMobileOpen}
                toggleMobileSidebar={toggleMobileSidebar}
            />
            <div className={`transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${isCollapsed ? 'lg:ml-20' : 'lg:ml-72'} min-h-screen flex flex-col`}>
                <Header toggleMobileSidebar={toggleMobileSidebar} />
                <main className="flex-1 p-6 space-y-6 overflow-x-hidden relative">
                    <div className="absolute top-0 left-0 right-0 h-64 bg-linear-to-b from-blue-50/50 to-transparent pointer-events-none" />
                    <div className="relative z-10">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    )
}

export default Layout
